export default __webpack_public_path__ + "static/media/logo-donmovies.05f77383.svg";